import owaEmptyState_lib_svg_HighContrast_illustration_taskSvg from 'owa-empty-state/lib/svg/HighContrast/illustration_task.svg';
import owaEmptyState_lib_svg_HighContrast_illustration_errorSvg from 'owa-empty-state/lib/svg/HighContrast/illustration_error.svg';
import owaEmptyState_lib_svg_HighContrast_illustration_flaggedSvg from 'owa-empty-state/lib/svg/HighContrast/illustration_flagged.svg';
import owaEmptyState_lib_svg_Light_illustration_taskSvg from 'owa-empty-state/lib/svg/Light/illustration_task.svg';
import owaEmptyState_lib_svg_Light_illustration_errorSvg from 'owa-empty-state/lib/svg/Light/illustration_error.svg';
import owaEmptyState_lib_svg_Light_illustration_flaggedSvg from 'owa-empty-state/lib/svg/Light/illustration_flagged.svg';
import owaEmptyState_lib_svg_Dark_illustration_taskSvg from 'owa-empty-state/lib/svg/Dark/illustration_task.svg';
import owaEmptyState_lib_svg_Dark_illustration_errorSvg from 'owa-empty-state/lib/svg/Dark/illustration_error.svg';
import owaEmptyState_lib_svg_Dark_illustration_flaggedSvg from 'owa-empty-state/lib/svg/Dark/illustration_flagged.svg';
import owaEmptyState_lib_svg_DarkTheme_illustration_taskSvg from 'owa-empty-state/lib/svg/DarkTheme/illustration_task.svg';
import owaEmptyState_lib_svg_DarkTheme_illustration_errorSvg from 'owa-empty-state/lib/svg/DarkTheme/illustration_error.svg';
import owaEmptyState_lib_svg_DarkTheme_illustration_flaggedSvg from 'owa-empty-state/lib/svg/DarkTheme/illustration_flagged.svg';
import owaEmptyState_lib_svg_LightTheme_illustration_taskSvg from 'owa-empty-state/lib/svg/LightTheme/illustration_task.svg';
import owaEmptyState_lib_svg_LightTheme_illustration_errorSvg from 'owa-empty-state/lib/svg/LightTheme/illustration_error.svg';
import owaEmptyState_lib_svg_LightTheme_illustration_flaggedSvg from 'owa-empty-state/lib/svg/LightTheme/illustration_flagged.svg';
import type { EmptyStateProps } from 'owa-empty-state/lib/components/EmptyState';
import {
    flaggedEmailTaskListEmptyStatePrimaryText,
    flaggedEmailTaskListEmptyStateSecondaryText,
    myDayTaskListEmptyStateSecondaryText,
    taskListErrorEmptyStateTryAgainSecondaryText,
    myDayTaskListEmptyStatePrimaryText,
    taskListErrorEmptyStateSecondaryText,
    taskListErrorEmptyStatePrimaryText,
} from './getEmptyStateProps.locstring.json';
import { getIsMsHighContrast } from 'owa-high-contrast';
import { getIsLightBaseTheme, getIsDarkBaseTheme } from 'owa-theme';
import { getIsDarkTheme } from 'owa-fabric-theme';
import loc from 'owa-localize';
import { assertNever } from 'owa-assert';
import { isHostAppFeatureEnabled } from 'owa-hostapp-feature-flags';

export function getErrorStateIcon() {
    if (getIsMsHighContrast()) {
        return owaEmptyState_lib_svg_HighContrast_illustration_errorSvg;
    } else if (getIsLightBaseTheme()) {
        return owaEmptyState_lib_svg_Light_illustration_errorSvg;
    } else if (getIsDarkBaseTheme()) {
        return owaEmptyState_lib_svg_Dark_illustration_errorSvg;
    } else if (getIsDarkTheme()) {
        return owaEmptyState_lib_svg_DarkTheme_illustration_errorSvg;
    } else {
        return owaEmptyState_lib_svg_LightTheme_illustration_errorSvg;
    }
}

export function getEmptyStateIcons() {
    let emptyStateIcon, emptyStateFlaggedIcon;

    if (getIsMsHighContrast()) {
        emptyStateIcon = owaEmptyState_lib_svg_HighContrast_illustration_taskSvg;
        emptyStateFlaggedIcon = owaEmptyState_lib_svg_HighContrast_illustration_flaggedSvg;
    } else if (getIsLightBaseTheme()) {
        emptyStateIcon = owaEmptyState_lib_svg_Light_illustration_taskSvg;
        emptyStateFlaggedIcon = owaEmptyState_lib_svg_Light_illustration_flaggedSvg;
    } else if (getIsDarkBaseTheme()) {
        emptyStateIcon = owaEmptyState_lib_svg_Dark_illustration_taskSvg;
        emptyStateFlaggedIcon = owaEmptyState_lib_svg_Dark_illustration_flaggedSvg;
    } else if (getIsDarkTheme()) {
        emptyStateIcon = owaEmptyState_lib_svg_DarkTheme_illustration_taskSvg;
        emptyStateFlaggedIcon = owaEmptyState_lib_svg_DarkTheme_illustration_flaggedSvg;
    } else {
        emptyStateIcon = owaEmptyState_lib_svg_LightTheme_illustration_taskSvg;
        emptyStateFlaggedIcon = owaEmptyState_lib_svg_LightTheme_illustration_flaggedSvg;
    }

    return {
        EMPTY_STATE_ICON: emptyStateIcon,
        ERROR_STATE_ICON: getErrorStateIcon(),
        EMPTY_STATE_FLAGGED_ICON: emptyStateFlaggedIcon,
    };
}

export function getMyDayEmptyStateMessages() {
    return {
        detailMessage: loc(myDayTaskListEmptyStateSecondaryText),
        mainMessage: loc(myDayTaskListEmptyStatePrimaryText),
    };
}

export function getErrorStateMessages() {
    const isNative = isHostAppFeatureEnabled('nativeMessaging');
    return {
        detailMessage: isNative
            ? loc(taskListErrorEmptyStateTryAgainSecondaryText)
            : loc(taskListErrorEmptyStateSecondaryText),
        mainMessage: loc(taskListErrorEmptyStatePrimaryText),
    };
}

export function getFlaggedEmptyStateMessages() {
    return {
        detailMessage: loc(flaggedEmailTaskListEmptyStateSecondaryText),
        mainMessage: loc(flaggedEmailTaskListEmptyStatePrimaryText),
    };
}

export type ListType = 'MyDay' | 'FlaggedEmail' | 'Error';

export function getEmptyStateProps(listType: ListType): EmptyStateProps {
    const { EMPTY_STATE_ICON, ERROR_STATE_ICON, EMPTY_STATE_FLAGGED_ICON } = getEmptyStateIcons();
    if (listType === 'MyDay') {
        return {
            icon: EMPTY_STATE_ICON,
            ...getMyDayEmptyStateMessages(),
        };
    } else if (listType === 'FlaggedEmail') {
        return {
            icon: EMPTY_STATE_FLAGGED_ICON,
            ...getFlaggedEmptyStateMessages(),
        };
    } else if (listType === 'Error') {
        return {
            icon: ERROR_STATE_ICON,
            ...getErrorStateMessages(),
        };
    } else {
        return assertNever(listType);
    }
}
